import { Link } from "react-router-dom";
import { Clock, ExternalLink, Mail, MapPin, Phone } from "lucide-react";
import { Logo } from "@/components/Logo";
import { CONTACT } from "@/constants/contact";

const COOKIE_KEY = "mac01_cookie_consent";

export const Footer = () => {
  const resetCookies = () => {
    localStorage.removeItem(COOKIE_KEY);
    window.dispatchEvent(new Event("mac01:reset-consent"));
  };

  return (
    <footer data-testid="site-footer" className="border-t border-border bg-card">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 pb-28 sm:pb-12 md:grid-cols-3">
        <div className="space-y-4">
          <Logo />
          <p className="text-sm text-muted-foreground">
            Réparation mécanique, entretien, diagnostic, pneus et dépôt-vente :
            votre garage de confiance à Pont-d'Ain.
          </p>
        </div>

        <div>
          <p className="mb-4 font-display text-sm font-semibold uppercase tracking-wider">
            Navigation
          </p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/" data-testid="footer-home-link" className="hover:text-foreground">Accueil</Link></li>
            <li><Link to="/#prestations" data-testid="footer-prestations-link" className="hover:text-foreground">Prestations</Link></li>
            <li><Link to="/occasions" data-testid="footer-occasions-link" className="hover:text-foreground">Occasions</Link></li>
            <li><Link to="/depot-vente" data-testid="footer-depot-vente-link" className="hover:text-foreground">Dépôt-vente</Link></li>
            <li><Link to="/pneus" data-testid="footer-pneus-link" className="hover:text-foreground">Pneus</Link></li>
            <li><Link to="/vehicule-de-pret" data-testid="footer-vehicule-pret-link" className="hover:text-foreground">Véhicule de prêt</Link></li>
            <li><Link to="/location-de-vehicule" data-testid="footer-location-link" className="hover:text-foreground">Location de véhicule</Link></li>
            <li><Link to="/convoyage" data-testid="footer-convoyage-link" className="hover:text-foreground">Convoyage auto</Link></li>
            <li><Link to="/#contact" data-testid="footer-contact-link" className="hover:text-foreground">Contact</Link></li>
            <li><Link to="/mentions-legales" data-testid="footer-mentions-legales-link" className="hover:text-foreground">Mentions légales</Link></li>
            <li><Link to="/politique-de-confidentialite" data-testid="footer-confidentialite-link" className="hover:text-foreground">Politique de confidentialité</Link></li>
          </ul>
        </div>

        <div>
          <p className="mb-4 font-display text-sm font-semibold uppercase tracking-wider">
            Contact
          </p>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-start gap-2">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
              <span data-testid="footer-address">{CONTACT.address}</span>
            </li>
            <li>
              <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2 hover:text-foreground">
                <Phone className="h-4 w-4 shrink-0 text-primary" /> {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="flex items-center gap-2 hover:text-foreground">
                <Mail className="h-4 w-4 shrink-0 text-primary" /> {CONTACT.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Clock className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
              <span data-testid="footer-hours">
                {CONTACT.hours.map((h) => (
                  <span key={h} className="block">{h}</span>
                ))}
              </span>
            </li>
            <li>
              <a
                href={CONTACT.centralepneusLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-centralepneus-link"
                className="flex items-center gap-2 hover:text-foreground"
              >
                <ExternalLink className="h-4 w-4 shrink-0 text-primary" />
                Station montage partenaire : Centralepneus.fr
              </a>
            </li>
            <li>
              <a
                href={CONTACT.brbImportLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-brb-link"
                className="flex items-center gap-2 hover:text-foreground"
              >
                <ExternalLink className="h-4 w-4 shrink-0 text-primary" />
                Partenaire import & dépôt-vente : BRB Import
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-4 text-xs text-muted-foreground sm:flex-row">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} {CONTACT.name} — SIRET {CONTACT.siret}
          </p>
          <button
            type="button"
            onClick={resetCookies}
            data-testid="footer-cookies-button"
            className="underline-offset-4 hover:underline"
          >
            Gérer les cookies
          </button>
        </div>
      </div>
    </footer>
  );
};
